import React from "react";
import { Popup } from "components/popups/Popup";
import Button from "components/shared/button";
import useTranslation from "utils/hooks/useTranslation";
import { PopupProps } from "./Popup";

export interface ConfirmationPopupProps extends PopupProps {
  title?: string;
  message?: string;
  isHtmlMessage?: boolean;
  positiveCallback: () => void;
  positiveButtonText?: string;
  negativeCallBack?: () => void;
  negativeButtonText?: string;
  hideNegativeButton?: boolean;
}

export const ConfirmationPopup: React.FC<ConfirmationPopupProps> = ({
  title = "",
  message = "",
  isHtmlMessage = false,
  positiveCallback,
  positiveButtonText: outerPositiveButtonText,
  negativeCallBack,
  negativeButtonText: outerNegativeButtonText,
  hideNegativeButton = false,
  ...rest
}) => {
  const { t } = useTranslation();
  const positiveButtonText = outerPositiveButtonText || t("yes");
  const negativeButtonText = outerNegativeButtonText || t("no");

  return (
    <Popup noHeader fixSize="middle" {...rest}>
      {({ onClose }) => {
        return (
          <group>
            <group data-space="30" data-direction="column">
              <text
                data-wrap="wrap"
                data-accent=""
                data-text-size="medium"
                data-wrap-line=""
              >
                {title}
              </text>
              <text data-wrap="wrap" data-text-size="medium" data-wrap-line="">
                {isHtmlMessage
                  ? <span dangerouslySetInnerHTML={{ __html: message }} />
                  : message
                }
              </text>
            </group>
            <group
              data-space="30"
              data-gap="10"
              data-background="highlight"
              data-type="grid"
            >
              <Button
                type="button"
                primary
                large
                autoFocus
                onClick={() => {
                  positiveCallback?.();
                  onClose?.();
                }}
              >
                <text>{positiveButtonText}</text>
              </Button>
              {!hideNegativeButton && (
                <Button
                  outline
                  large
                  type="button"
                  onClick={() => {
                    negativeCallBack?.();
                    onClose?.();
                  }}
                >
                  <text>{negativeButtonText || "Cancel"}</text>
                </Button>
              )}
            </group>
          </group>
        );
      }}
    </Popup>
  );
};
